import { useCallback, useState } from "react";
import { EndedSelectionContext } from "../contexts/endedSelection";

export default function EndedSelectionProvider({ children }) {
  const [selectedIds, setSelectedIds] = useState([]);

  const toggleSelection = useCallback((id) => {
    setSelectedIds((curr) =>
      curr.includes(id) ? curr.filter((x) => x !== id) : [...curr, id]
    );
  }, []);

  const clearSelection = useCallback(() => setSelectedIds([]), []);

  return (
    <EndedSelectionContext.Provider value={{ selectedIds, toggleSelection, clearSelection }}>
      {children}
    </EndedSelectionContext.Provider>
  );
}
